import { useEffect } from "react";
import { getEngine, resetEngine } from "../context/commerce-engine-csr";
import useOneTrust from "@greystar/ui/src/hooks/useOneTrust";
import useCookieManager from "@greystar/ui/src/hooks/useCookieManager";

export const useCoveoAnalytics = () => {
  const { consentGroups } = useOneTrust();
  const { removeCookie } = useCookieManager();

  useEffect(() => {
    if (consentGroups["performance"] === undefined) {
      return;
    }

    resetEngine();
    const engine = getEngine(consentGroups["performance"]);

    if (consentGroups["performance"]) {
      engine.enableAnalytics();
    } else {
      if (typeof document !== "undefined") {
        document.cookie = `coveo_visitorId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.greystar.com`;
        document.cookie = `coveo_visitorId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=apex-stage.greystar.com`;
        document.cookie = `coveo_visitorId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.sitecorecloud.io`;
        removeCookie("coveo_visitorId");
      }
      localStorage.removeItem("visitorId");

      engine.disableAnalytics();
    }
  }, [consentGroups]);
};
